import { render, staticRenderFns } from "./UserViewPage.vue?vue&type=template&id=cccef2b0&"
import script from "./UserViewPage.vue?vue&type=script&lang=js&"
export * from "./UserViewPage.vue?vue&type=script&lang=js&"
import style0 from "./UserViewPage.vue?vue&type=style&index=0&id=cccef2b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports